export default __webpack_public_path__ + "static/media/lb-success.13379f2d.svg";